import { useMutation, useQueryClient } from '@tanstack/react-query'
import { PERSONAL_ACCESS_TOKENS_QUERY_KEY } from './usePersonalAccessTokens'
import { revokePersonalAccessToken } from '@/lib/api/features/personal-access-tokens'

export function useRevokePersonalAccessToken() {
  const queryClient = useQueryClient()
  return useMutation<void, Error, string>({
    mutationFn: revokePersonalAccessToken,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PERSONAL_ACCESS_TOKENS_QUERY_KEY })
    },
  })
}
